<div class="profile-box-area">
    <div class="profile-box-img mr-2">
      <img
        *ngIf="shipperInfo.logoUrl !== ' '"
        src="{{ shipperInfo.logoUrl }}"
        onError="this.onerror=null;this.src='../../../../../../assets/images/person-ic.jpg';"
        alt="profile-image"
      />
    </div>
    <div class="profile-box-info">
      <h3>{{ shipperInfo.companyName }}</h3>
      <div
        *ngIf="userSuperAdmin == false"
        [ngClass]="{ active: shipperInfo?.isFavorite }"
        class="like-area"
      >
        <span class="material-icons" (click)="onMarkFavourite(shipperInfo)">
          favorite_border
        </span>
      </div>
      <div>
        <ngx-stars
          #ratingChange
          initialStars="{{ shipperInfo?.rating }}"
          totalstars="{{ totalstar }}"
          [color]="'#51af57'"
          size="24px"
          [readonly]="true"
        ></ngx-stars>
      </div>
      <!-- <div class="reviews-number">
        {{ shipperInfo.rating }} Ratings and {{ shipperInfo.reviews }} Reviews
      </div> -->
      <div class="reviews-number">
        {{ shipperInfo.rating }}
        {{ shipperInfo.rating > 1 ? "Ratings" : "Rating" }}
        and
        {{ shipperInfo.reviews }}
        {{ shipperInfo.reviews > 1 ? "Reviews" : "Review" }}
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <hr />
      </div>
      <div
        *ngIf="userSuperAdmin == false"
        class="col-sm-12 d-flex align-items-center justify-content-between"
      >
        <label class="f-14 fw-500 mb-0">Total Job Posted: </label>
        <span class="badge-label bg-green">{{ shipperInfo.totalJobs }}</span>
      </div>
    </div>
</div>
